import { render, staticRenderFns } from "./declare.vue?vue&type=template&id=7dd9f3f2&scoped=true"
import script from "./declare.vue?vue&type=script&lang=js"
export * from "./declare.vue?vue&type=script&lang=js"
import style0 from "./declare.vue?vue&type=style&index=0&id=7dd9f3f2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd9f3f2",
  null
  
)

export default component.exports